import { render, staticRenderFns } from "./repairSettingList.vue?vue&type=template&id=529c0bb0&scoped=true"
import script from "./repairSettingList.vue?vue&type=script&lang=js"
export * from "./repairSettingList.vue?vue&type=script&lang=js"
import style0 from "./repairSettingList.vue?vue&type=style&index=0&id=529c0bb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529c0bb0",
  null
  
)

export default component.exports